import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const asaTrades: SeasonTrades[] = [
  {
    season: "2010/11",
    allTrades: [
      {
        otherTeam: manager.itay,
        sentAway: "Andrew Bogut",
        gotInReturn: "Andrea Bargnani",
      },
    ],
  },
];
